import React from 'react';
import { useParams } from 'react-router';
import { Container, Grid } from '@material-ui/core';
import PaymentMethodsList from './components/PaymentMethodsList';
import ClientEditSidebar, {
    ACTIVE_CLIENT_SIDEBAR_TAB_NAMES
} from '../clientedit/ClientEditSidebar';

function ClientPaymentMethodsPage() {
    const { clientId } = useParams();

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <ClientEditSidebar activeTab={ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.paymentmethods} />
                <Grid className="pageContent">
                    <PaymentMethodsList clientId={clientId} />
                </Grid>
            </Grid>
        </Container>
    );
}

export default ClientPaymentMethodsPage;
